module.exports = __webpack_public_path__ + "img/service-banner2.58cae96f.png";